export const pageGroup = 'edit_business_profile'
const pageName = 'edit_page'
export const commonProperties = { pageGroup, pageName }

export const EDIT_PROFILE_SCREEN_SHOWN_FPTI = {
  ...commonProperties,
  eventName: 'edit_bp_page_shown',
}

export const REVIEW_PROFILE_PANEL_NEXT_BUTTON_FPTI = JSON.stringify({
  ...commonProperties,
  eventName: 'edit_bp_page_next_button_click',
})

export const EDIT_BP_ABANDON_POPUP_SHOWN = {
  ...commonProperties,
  eventName: 'edit_bp_abandon_popup_shown',
}
